export enum SidePanelId {
    AltLogin = 'Alt-login',
    Connections = 'Connections',
    Inform = 'Inform',
    Chat = 'Chat',
    Voip = 'Voip',
}
